import React, { useEffect, useState } from 'react';
import { useGetApiRequests, useNavigate, useDispatch, useForm, SubmitHandler, Controller, yupResolver, Button, Input, storeData, Heading, ErrorMessage, triggerNotification } from '../../common/CommonExport';
import { setToken } from '../../redux/slices/authSlice';
import { LoginFormSchema } from './LoginFormSchema';
import showPassword from '../../assets/images/eyeOpen.svg';
import hidePassword from '../../assets/images/eyeClose.svg';
import { setUserData } from '../../redux/slices/userDataSlics';
import GoogleLogin from './GoogleLogin';
import { setOrgId } from '../../redux/slices/orgSlice';
import Loader from '../../components/Loader/Loader';
import { setRolePermissions } from '../../redux/slices/rolePermissionsSlice';
import { setUserId } from '../../redux/slices/userIdSlice';
import { setOrgName } from '../../redux/slices/OrganisationNameSlice';
import { setEmployeePermission, setHrLogin, setIsAdmin, setSwitchIcon } from '../../redux/slices/employeePermissionSlice';
import { setEmployeeDetails } from '../../redux/slices/employee/employeeDetailsSlice';
import { useIsMobile } from '../../hooks/commonHooks';
import MobileWarningModal from '../../components/modal/MobileWarningModal/MobileWarningModal';
import PopupModal from '../employee/employee-details/employee-profile/modal/PopupModal';
import keycloak from '../../hooks/keycloak';

interface LoginFormPayload {
    email: string;
    password: string;
}

const LoginForm: React.FC = () => {
    const isMobile = useIsMobile();

    const LoginApi = useGetApiRequests('login', 'POST');
    const loginUserDetails = useGetApiRequests('userLoginDetails', 'GET');
    const loginEmployeeDetails = useGetApiRequests('getEmployeeDetails', 'GET');
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [passwordVisible, setPasswordVisible] = useState<boolean>(false);
    const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
    const [modalerrMessage, setModalErrMessage] = useState('')
    const [popModal, setPopModal] = useState(false)
    const [modalResponse, setModalResponse] = useState('')
    const [modalButtonShow, setmodalButtonShow] = useState(true)

    const handleClosePopUpModal = () => {
        setPopModal(false)
    }
    const {
        handleSubmit,
        formState: { errors },
        control,
        getValues,
    } = useForm<LoginFormPayload>({
        resolver: yupResolver(LoginFormSchema) as any,
    });

    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };

    useEffect(() => {
        const doc = document.getElementById("root")
        setTimeout(() => {
            doc?.click()

        }, 2000);
    }, [])

    useEffect(() => {
        if (!isMobile && isModalVisible) {
            setIsModalVisible(false);
        }
    }, [isMobile, isModalVisible]);

    const handleGetEmployeeDetails = async (employeeId: any) => {
        try {
            const response: any = await loginUserDetails('', {}, { employeeId })
            if (response?.data?.status?.success === 'Success') {
                dispatch(setRolePermissions(response?.data?.data?.role?.rolePermissions));
                dispatch(setUserData(response.data));
                dispatch(setOrgName(response.data.data?.role?.organisation?.name));

                storeData('userId', response?.data?.data?.userId, true);
                storeData('loginUserData', response?.data?.data, true);
                sessionStorage.setItem("hrDeptId", response?.data?.data?.role?.organisation?.hrDeptId)
                storeData('isLoggedIn', true, true);
                dispatch(setSwitchIcon(true))
                navigate('/home/dashboard');
                setLoader(false)
            }
        } catch (err: any) {
            setPopModal(true)
            setmodalButtonShow(false)
            setModalErrMessage(err?.response?.data?.status?.message ?? err?.message)
            setModalResponse('error')
            setTimeout(() => {
                handleClosePopUpModal();
                setLoader(false);
            }, 1500)
        }
    }

    const configureHRandReportingManager = (employeeId: string | number, hrLogin: boolean) => {
        dispatch(setHrLogin(hrLogin))
        handleGetEmployeeDetails(employeeId)
        dispatch(setEmployeePermission(false))
    }


    const onSubmit: SubmitHandler<LoginFormPayload> = (data: LoginFormPayload) => {
        const payload: any = {
            email: data.email,
            password: data.password,
            keycloakClientId: 0
        };

        setLoader(true);
        LoginApi(payload)
            .then((response: any) => {
                const employeeId = JSON.parse(response?.data?.data?.employeeId)[0]
                const { roles } = response?.data?.data
                storeData('loggedInEmployeeId', employeeId, true);
                storeData('authToken', response?.data?.data?.accessToken, true);

                dispatch(setOrgId(JSON.parse(response?.data?.data?.organisationId)[0]));
                dispatch(setUserId(employeeId));
                dispatch(setToken(response?.data?.data?.accessToken));
                if (roles && roles.some((role: any) => role.name === "admin")) {
                    dispatch(setIsAdmin(true))
                    //find HR login 
                    if (roles?.length === 1) {
                        if (isMobile) {
                            setIsModalVisible(true);
                            setLoader(false);
                        } else {
                            configureHRandReportingManager(employeeId, true)
                        }
                    } else {
                        if (isMobile) {
                            getEmployeeDetails(employeeId)
                            handleGetEmployeeDetails(employeeId)
                        } else {
                            configureHRandReportingManager(employeeId, false)
                        }
                    }

                } else {
                    dispatch(setIsAdmin(false))
                    getEmployeeDetails(employeeId, true)

                }
            })
            .catch((err: any) => {
                setPopModal(true)
                setmodalButtonShow(false)
                setModalErrMessage(err?.response?.data?.message ?? err?.message)
                setModalResponse('error')
                setTimeout(() => {
                    handleClosePopUpModal();
                    setLoader(false);
                }, 1500)
            });
    };


    const getEmployeeDetails = async (employeeId: number | string, isEmployee: boolean = false) => {
        try {
            const response: any = await loginEmployeeDetails('', {}, { employeeId })
            const data = await response.data
            if (data?.status === 200) {
                dispatch(setEmployeePermission(isEmployee))
                dispatch(setEmployeeDetails(data?.data));
                if (isEmployee) {
                    dispatch(setSwitchIcon(false))
                    navigate('/user-dashboard');
                } else {
                    dispatch(setSwitchIcon(true))
                    navigate('/home/dashboard');
                }

            }
            setLoader(false);

        } catch (err: any) {
            setPopModal(true)
            setmodalButtonShow(false)
            setModalErrMessage(err?.response?.data?.status?.message ?? err?.message)
            setModalResponse('error')
            setTimeout(() => {
                handleClosePopUpModal();
                setLoader(false);
            }, 1500)
        }
    }

    const handleResetPassword = () => {
        const formData = getValues();

        if (formData.email) {
            navigate(`/forgot-password?email=${formData?.email}`);
        } else {
            navigate('/forgot-password')
        }
    }
    return (
        <div className='w-full h-100% px-5 md:px-0  md:pt-0 md:min-h-screen flex items-center justify-center login-form '>
            <div className='w-full mx-auto my:auto bg-transparent sign-input'>
                <h2 className='text-black text-2xl md:text-3xl font-normal tracking-wide mb-1'>Sign In</h2>
                <p className=' hidden md:block text-gray-500 font-normal text-base leading-5 font-roboto font-helvetica-neue font-sans tracking-normal mt-2 md:mt-4'>Sign in to your account</p>
                <div className='w-full md:w-9/12 mt-8 md:mt-12  md:mb-0'>
                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                        <div className='relative z-0 mt-5 sign_in'>
                            <Controller name='email' control={control} render={({ field }) => <Input type='email' id='email' label='Email*' control={control} {...field} hasError={!!errors.email} />} />
                        </div>
                        {errors.email && <ErrorMessage message={errors.email.message} />}
                        <div className='relative z-0 mt-10 sign_in'>
                            <Controller name='password' control={control} render={({ field }) => <Input type={passwordVisible ? 'text' : 'password'} id='password' label='Password*' control={control} {...field} hasError={!!errors.password} />} />
                            <img className='cursor-pointer eyeIcon right-0 absolute w-5 top-2 md:top-3 right-2' alt='passwordVisibility' title={passwordVisible ? 'Show password' : 'Hide password'} src={passwordVisible ? showPassword : hidePassword} onClick={() => togglePasswordVisibility()} />
                        </div>
                        {errors.password && <ErrorMessage message={errors.password.message} />}
                        <div className='flex items-center justify-between mt-8  md:mt-16 md:mb-12 login-forgot-password'>
                            <p className='font-roboto text-sm font-medium cursor-pointer text-indigo-600 mb-4 lg:mb-0' onClick={() => handleResetPassword()}>Forgot Password?</p>
                            <Button type='submit' variant='primary' label='SIGN IN' />
                        </div>
                    </form>
                    <div className='mt-8 mb-8 hidden md:block'>
                        <h2 className='border-gray-300 w-full text-center border-b leading-3 '>
                            <span className='bg-white px-6 py-4'>or</span>
                        </h2>
                    </div>
                    <div className=' mt-4 md:mt-0'>
                        <GoogleLogin />
                    </div>
                    <div className=' mt-4 md:mt-4'>
                        <Button
                            type='button'
                            variant='primary'
                            label='Login with Akku'
                            icon={<img src="https://storage.googleapis.com/akku-theme/Akku2.0/img/akku-copyright.png" alt="Akku Logo" className="w-5 h-5 mr-2" />}
                            iconPosition='start'
                            onClick={() => keycloak.login()}
                            className='!w-full justify-center'
                        />
                    </div>
                </div>
            </div>
            <MobileWarningModal isModalVisible={isModalVisible} />
            {loader && <Loader />}
            {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
        </div>
    );
};

export default LoginForm;
